import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import CustomSnapshotTool from '@containers/DigitalAnalyst/CustomSnapshotTool';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

function CustomSnapshot() {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <CustomSnapshotTool onGoBack={onGoBack} />
      </Body>
    </PageWrapper>
  );
}

export default CustomSnapshot;
